export enum ExternalDataTerminalTypeEnum {
  NON_THREE_DS = 'NON_THREE_DS',
  THREE_DS = 'THREE_DS',
}
